<div class="card mb-3">
  <div class="card-body">
    <h1>Report Summary</h1>
    <app-report-summary></app-report-summary>
  </div>
</div>
